import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-d5c32340"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "tw-text-right tw-pt-[20px] tw-pr-[20px] tw-pl-[40px] tw-leading-[12px]"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tw-w-3 tw-h-3",
  src: _imports_0,
  alt: "close"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "tw-text-[15px] tw-text-[#231F20] tw-font-[400] tw-leading-[145%]" }
const _hoisted_5 = {
  key: 0,
  class: "tw-font-[500] tw-pl-[2px]"
}
const _hoisted_6 = { class: "button-container-bottom tw-flex tw-justify-end tw-px-[20px] tw-pb-[20px] sm:tw-px-[40px] sm:tw-pb-[40px]" }
const _hoisted_7 = { class: "tw-text-[15px] tw-leading-[100%] tw-font-[500] tw-font-[Poppins]" }

import store from "../../store";
import utilities from "../../utils/utilities";
import { computed, ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import ModalHeader from "../common/modalHeader.vue";
import Button2 from "../common/button2.vue";
import Button1 from "../common/button1.vue";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "@/assets/animation/progress_dark.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'manageUserModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  header: {
    type: Boolean,
    required: false,
  },
  redBtn: {
    type: Boolean,
    required: false,
  },
  headerTitle: {
    type: String,
    required: false,
    default: "Header Title",
  },
  containTitle: {
    type: String,
    required: true,
  },
  containSubTitle: {
    type: String,
    required: true,
  },
  actionTitle: {
    type: String,
    required: true,
  },
  requiredShowLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  isLoadingButton: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:show", "update:actionHandle"],
  setup(__props, { emit }) {

const props = __props;




const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};

let showRef = ref(props.show);
let newDomainValue = ref("");

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (props.show === true) newDomainValue.value = "";
  },
);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleActionClick = () => {
  emit("update:actionHandle", showRef.value);
  !props.requiredShowLoading && (showRef.value = false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": 38,
    "style-class-contain": styleClassContain,
    "class-name": `tw-z-[1071]`
  }, {
    default: _withCtx(() => [
      (__props.header)
        ? (_openBlock(), _createBlock(ModalHeader, {
            key: 0,
            title: getUiText(__props.headerTitle),
            class: _normalizeClass('tw-px-[20px] sm:tw-px-[40px]'),
            onClose: handleCloseModal
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (!__props.header)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("a", {
              href: "#",
              onClick: handleCloseModal
            }, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(`tw-px-[20px] tw-pb-[40px] sm:tw-px-[40px] ${
        __props.header ? 'tw-pt-[20px] sm:tw-pt-[40px]' : 'tw-pt-[8px]'
      }`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`tw-text-[25px] tw-text-[#211F58] tw-font-[Poppins] tw-font-[600] tw-mb-[15px] ${
          __props.header ? 'tw-leading-[100%]' : 'tw-leading-normal'
        }`)
        }, _toDisplayString(getUiText(__props.containTitle)), 3),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(getUiText(__props.containSubTitle)), 1),
          (__props.header)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " " + _toDisplayString(getUiText(
              "app-settings-team-members-profile-modal-delete-action-helper-b-1",
            )), 1))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Button2, {
          title: getUiText('app-settings-domain-delete-modal-action-cancel-1'),
          "data-cy": "manage-user-modal-cancel",
          class: _normalizeClass('tw-text-[15px] tw-leading-[100%] tw-mr-[15px] tw-pl-[18px] tw-pr-[18px] tw-py-[12px] tw-rounded-[27px]'),
          onClick: handleCloseModal
        }, null, 8, ["title"]),
        (__props.isLoadingButton)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: _normalizeClass(`tw-overflow-hidden tw-h-[43px] tw-text-[15px] tw-leading-[100%] !tw-px-[18px] tw-rounded-[27px] ${
          __props.redBtn
            ? '!tw-bg-[#F7553C] hover:!tw-bg-[#c82333]'
            : 'hover:!tw-bg-[#0056b3]'
        } `)
            }, [
              _createVNode(_unref(LottieAnimation), {
                class: _normalizeClass('tw-h-[43px] tw-w-full'),
                "animation-data": _unref(ProgressAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(getUiText(__props.actionTitle)), 1)
            ], 2))
          : (_openBlock(), _createBlock(Button1, {
              key: 1,
              title: getUiText(__props.actionTitle),
              "data-cy": `manage-user-modal-${__props.actionTitle}`,
              class: _normalizeClass(`tw-text-[15px] tw-leading-[100%] !tw-px-[18px] !tw-py-[14px] tw-rounded-[27px] ${
          __props.redBtn
            ? '!tw-bg-[#F7553C] hover:!tw-bg-[#c82333]'
            : 'hover:!tw-bg-[#0056b3]'
        } `),
              disabled: false,
              onClick: handleActionClick
            }, null, 8, ["title", "data-cy", "class"]))
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})